import { VideoEditor } from './VideoEditor';

/**
 * Observer interface for the Editor
 * Any class that wants to observe editor changes should implement this interface
 */
export interface EditorObserver {
  // Method to be called when a change occurs
  onEditorChange(
    editor: VideoEditor,
    changeType: EditorChangeType,
    payload?: any,
  ): void;
}

/**
 * Types of changes that can occur in the editor
 */
export enum EditorChangeType {
  // Timeline related
  TIMELINE_CHANGED = 'timeline_changed',
  PROJECT_LOADED = 'project_loaded',
  FRAMERATE_CHANGED = 'framerate_changed',
  SNAP_TO_FRAME_CHANGED = 'snap_to_frame_changed',

  // Transcript related
  TRANSCRIPT_LOADED = 'transcript_loaded',
  TRANSCRIPT_MODIFIED = 'transcript_modified',
  ACTIVE_TRANSCRIPT_CHANGED = 'active_transcript_changed',

  // Element related
  ELEMENT_ADDED = 'element_added',
  ELEMENT_REMOVED = 'element_removed',
  ELEMENT_UPDATED = 'element_updated',
  ELEMENT_SHIFTED = 'element_shifted',
  ELEMENT_TRACK_CHANGED = 'element_track_changed',
  ELEMENT_TRIMMED_START = 'element_trimmed_start',
  ELEMENT_TRIMMED_MEDIA_START = 'element_trimmed_media_start',
  ELEMENT_TRIMMED_END = 'element_trimmed_end',
  ELEMENT_MERGED = 'element_merged',
  ELEMENT_SPLIT = 'element_split',
  ELEMENT_SPLIT_UNDONE = 'element_split_undone',

  // Track related
  TRACK_ADDED = 'track_added',
  TRACK_REMOVED = 'track_removed',
  TRACK_LAYER_CHANGED = 'track_layer_changed',

  // Batch related
  BATCH_STARTED = 'batch_started',
  BATCH_COMPLETED = 'batch_completed',

  // Command related
  COMMAND_EXECUTED = 'command_executed',
  COMMAND_UNDONE = 'command_undone',
  COMMAND_REDONE = 'command_redone',

  // Selection related
  SELECTION_CHANGED = 'selection_changed',

  // Integration related
  EXTERNAL_STATE_CHANGE = 'external_state_change',
}
